import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/ShadersInclude/morphTargetsVertexGlobal.js
var name, shader, morphTargetsVertexGlobal;
var init_morphTargetsVertexGlobal = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/morphTargetsVertexGlobal.js"() {
    init_shaderStore();
    name = "morphTargetsVertexGlobal";
    shader = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
float vertexID;
#endif
#endif
`;
    ShaderStore.IncludesShadersStore[name] = shader;
    morphTargetsVertexGlobal = { name, shader };
  }
});

export {
  morphTargetsVertexGlobal,
  init_morphTargetsVertexGlobal
};
